<crm-single-select
  #singleSelectComponent
  [options]="entities"
  optionLabel="profile.name"
  filterBy="profile.name"
  [isFilterSelectedItem]="true"
  [(selectedItem)]="_selectedEntity"
  (selectedItemChange)="onSelect($event)"
  (onShow)="onShowPanel()"
  (onHide)="onHidePanel()"
  (onFilter)="search($event.filter)"
  [label]="labelInput ? 'Пользователь' : ''"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [disabled]="disabled"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [sort]="customSearch ? sort : ''"
  [itemSubDescriptionField]="itemSubDescriptionField"
  [isTemplateCombined]="true"
  [loading]="loading || selectionLoading">
  <ng-template
    #itemTemplate
    let-user="item">
    <ng-container *ngIf="toUser(user) as user">
      <div class="flex align-items-center gap-2">
        <div>
          <span [innerHTML]="highlightMatchText(user.profile?.name) | safeHtml"></span>
        </div>
        <div
          *ngIf="user?.banned"
          class="font-medium text-red-500">
          (Заблокирован)
        </div>
        <div
          *ngIf="user?.deleted"
          class="font-medium text-red-500">
          (удалён)
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
